import { render } from "./EventCard.vue?vue&type=template&id=c2f6d326&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=c2f6d326&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2f6d326"

export default script